
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/documentation",
      function () {
        return require("private-next-pages/documentation/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/documentation"])
      });
    }
  